import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { WorkspaceModule } from '@shared/types/planner';
import type { TaskViewMode } from '@shared/types/planner';

interface WorkspaceState {
  activeEventId: string | null;
  activeModule: WorkspaceModule;
  sidebarCollapsed: boolean;
  taskViewMode: TaskViewMode;
  budgetScenario: 'economy' | 'mid' | 'premium' | 'custom';
  theme: 'light' | 'dark' | 'system';

  setActiveEvent: (id: string | null) => void;
  setModule: (module: WorkspaceModule) => void;
  toggleSidebar: () => void;
  setTaskViewMode: (mode: TaskViewMode) => void;
  setBudgetScenario: (scenario: 'economy' | 'mid' | 'premium' | 'custom') => void;
  setTheme: (theme: 'light' | 'dark' | 'system') => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeEventId: null,
      activeModule: 'dashboard',
      sidebarCollapsed: false,
      taskViewMode: 'list',
      budgetScenario: 'mid',
      theme: 'system',

      setActiveEvent: (id) => set({ activeEventId: id }),
      setModule: (module) => set({ activeModule: module }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setTaskViewMode: (mode) => set({ taskViewMode: mode }),
      setBudgetScenario: (scenario) => set({ budgetScenario: scenario }),
      setTheme: (theme) => {
        set({ theme });
        if (theme === 'system') {
          document.documentElement.removeAttribute('data-theme');
        } else {
          document.documentElement.setAttribute('data-theme', theme);
        }
      },
    }),
    {
      name: 'eventroy-workspace',
    },
  ),
);
